export default {
    CREATE: "Создать",
    CANCEL: "Отменить"
};
